/// <reference path="../typings/ima.d.ts" />
import loadScript from './loadScript';
var imaSdkSrc = '//imasdk.googleapis.com/js/sdkloader/ima3.js';
var pendingPromise = null;
var promiseFinished = function () {
    pendingPromise = null;
};
var loadImaSdk = function () {
    if (window.google && window.google.ima) {
        return Promise.resolve(window.google.ima);
    }
    if (pendingPromise) {
        return pendingPromise;
    }
    pendingPromise = loadScript(imaSdkSrc).then(function () { return window.google.ima; });
    pendingPromise.then(promiseFinished).catch(promiseFinished);
    return pendingPromise;
};
export default loadImaSdk;



// WEBPACK FOOTER //
// ./node_modules/@alugha/ima/lib/esm/loadImaSdk.js